import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue'
import type { Ref } from 'vue'
import { useSubmit } from './FormMixin'
import {
  authenticateCreate,
  authenticateConfirm,
  authResource,
  passwordConfirm,
} from '@/services/auth.service'
import useDeviceInfo from '@/composables/useDevice'
import { storage } from '@/utils/session'
import { urlGetParamsGetter } from '@/utils/urlGetParams'

import useGlobal from '../../composables/useGlobal'



export default /*#__PURE__*/_defineComponent({
  __name: 'PassSetForm',
  props: ['cabinetLink', 'testLink', 'subscriptionsLink'],
  setup(__props, { expose }) {
  expose();

const props = __props


const { $t } = useGlobal()
// import {
  // useAuth,
  // } from '@/stores/auth'
  
// const store = useAuth()
//  DONT USED VAR!!!!!!!!!!!!!!!!
console.log("🚀 ~ file: PassSetForm.vue:63 ~ uidb64Getter:", urlGetParamsGetter('token'))

const authId = ref("")
const form = ref({
  new_password: '',
  new_password1: '',
})
const load: Ref<boolean> = ref(false)
const activeTimer = ref(false)
const email = ref("")
const code = ref("")
const formIsSended = ref(false)
const emailError = ref($t('Не подходящий email'))
const timeIsOver = ref(false)
const request = (sendData: any, control: any) => {
  useSubmit(send(sendData, control), control)
}

const tokenId: Ref<string> = ref('')
const twoFactorId: Ref<string> = ref('')
//  exemple@gmail.com
const send = async (sendData, control) => {
  load.value = true
  const preparedData = {
    uidb64: urlGetParamsGetter('uidb64'),
    token: urlGetParamsGetter('token')
  }

  try {
    const data = (await passwordConfirm.execute({...preparedData}, {...form.value,}))
    load.value = false
    formIsSended.value = true
    setTimeout(() => {
      window.location.href = props.cabinetLink
    }, 3000);
  } catch(e) {
      e.json().then(body => {
        Object.keys(body).forEach(key => {
          control.setFieldError(key, body[key][0])
        })
      })
      load.value = false
      return Promise.reject(e)
  }
}


const __returned__ = { props, $t, authId, form, load, activeTimer, email, code, formIsSended, emailError, timeIsOver, request, tokenId, twoFactorId, send, ref, useSubmit, authenticateCreate, authenticateConfirm, authResource, passwordConfirm, useDeviceInfo, storage, urlGetParamsGetter, useGlobal }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})